import { render, staticRenderFns } from "./LogoArea.vue?vue&type=template&id=baaaab4a&"
import script from "./LogoArea.vue?vue&type=script&lang=js&"
export * from "./LogoArea.vue?vue&type=script&lang=js&"
import style0 from "./LogoArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports